import React from 'react';
import { Link } from 'react-router-dom';
import './Photographyheader.css';

const Photography = ({ content = {} }) => {
  return (
    <section
      className="Photography"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${content.heroImage || '/photography.jpg'})` }}
    >
      <div className="overlay"></div>
      <div className="content">
        <h1>{content.title || 'Photography Services in Bonney Lake, Tacoma & the Puget Sound'}</h1>
        <div className="underline"></div>
        <div className="button-container">
          <Link to="/drone-photography" className="photo-btn">Drone Photography</Link>
          <Link to="/wedding-photography" className="photo-btn">Wedding Photography</Link>
      
        </div>
      </div>
    </section>
  );
};

export default Photography;
